import React from "react";

import { useTranslation } from "react-i18next";

import { FormDateInput } from "@/uiKit/molecules/form/FormDateInput.tsx";

export type BirthDateFormFieldProps = {
  name?: string;
  className?: string;
  labelType?: "left" | "default";
};

export const BirthDateFormField: React.FC<BirthDateFormFieldProps> = ({ name = "birthDate", labelType, className }) => {
  const { t } = useTranslation();

  return (
    <FormDateInput
      id="birth-date-form-field"
      name={name}
      label={t("profile.birthDate")}
      labelType={labelType}
      className={className}
      reserveErrorSpace
      autoComplete="bday"
    />
  );
};
